import { PageLayout } from "~/components/PageLayout";
import { SuccessfulPayment } from "~/components/SuccessfulPayment";

export const PaymentSuccessPage = () => {
  return (
    <PageLayout>
      <SuccessfulPayment />
    </PageLayout>
  );
};
